import React from 'react';
import { useSelector } from 'react-redux';

import { Anchor, DetailedIconStarRising } from '@zillow/constellation';
import { Paragraph } from '@zillow/constellation-10';

import emailUtils from '../../../../utils/emailUtils';
import { PropertiesSelectors, UserSelectors } from '../../../../selectors';

const Confirmation = () => {
  const { isMultifamilyCustomer, isSingleFamilyEnterpriseCustomer } = useSelector((state) =>
    UserSelectors.makeUser(state),
  );
  const { isMultifamily } = useSelector((state) => PropertiesSelectors.makeCurrentProperty(state));
  const email = emailUtils.getHelpEmail(isMultifamily && isMultifamilyCustomer, isSingleFamilyEnterpriseCustomer);

  return (
    <>
      <DetailedIconStarRising />
      <Paragraph css={{ textStyle: 'heading-sm', marginBlock: '400' }}>
        This listing will be deactivated as of today. Your advertising period will be included on your next invoice.
      </Paragraph>
      <Paragraph>
        If you’re unsatisfied with our service, we want to hear how we can help.&nbsp; Please email&nbsp;
        <Anchor as="a" href={`mailto:${email}`}>
          {email}
        </Anchor>
      </Paragraph>
    </>
  );
};

export default Confirmation;
